import React from "react";
import { FaFilePdf } from "react-icons/fa";
import GitHubCalendar from "react-github-calendar";
import { useStores } from "../../store";
import { MdPersonAddAlt } from "react-icons/md";
import { apiPostPut } from "../../api/api_methods";
import { useState } from "react";
import Loader from "../reusble_components/loader";
export default function Information(props) {
  const {CommonStore} =useStores();
  // useEffect(() => {
  //   window.addEventListener('resize', adjustGridColumns);
  // adjustGridColumns();
  // }, []);
const [loading,setLoading]=useState(false); 
  const {
    nameOfInstitute,
    mailID,
    linkedinURI,
    year,
    location,
    age,
    githubURI,
    nameOfCompany,
    yearsOfExperience,
    tech,
    communication,
    mobile,
    gender,
    overallRating,
    lookingFor,
  } = props;
  // function adjustGridColumns() {
  //   const gridContainer = document.getElementById('gridContainer');
  //   if (window.innerWidth < 1300) {
  //     gridContainer.classList.remove('grid-cols-3');
  //     gridContainer.classList.add('grid-cols-2');
  //   } else {
  //     gridContainer.classList.remove('grid-cols-2');
  //     gridContainer.classList.add('grid-cols-3');
  //   }
  // }
  const hireCandidate=async()=>{
    const role=prompt("Enter the role for which you want to hire this candidate");
    if(role){
      setLoading(true);
      const userId=JSON.parse(localStorage.getItem('user'))._id;
      const candidateId=props.id;
      console.log(userId,candidateId,role);
      const body={typeOfWork:role,userId:candidateId,recruiterId:userId}
      const response= await apiPostPut(body,'/interview/hire-candidate',"POST");
      if(response.status==200){
        setLoading(false);
        alert("You have successfully hired this candidate, we have send you the mail to candidate behalf of you, for more information contact the candidate");
      }else{
        setLoading(false);
        alert("Something went wrong");
      }
    }
  };

  return (
    <div className="bg-white md:rounded-3xl md:min-h-[750px] ">
    <Loader loader={loading}></Loader>
      <div className="flex justify-between items-center p-5 md:p-10">
        <p className="font-bold text-xl ">Basic information</p>
        <span className="hidden  md:flex md:space-x-4 ">
          {/* <span className="border border-primary rounded-xl p-2 flex justify-around items-center min-w-[30vh]  text-primary">
            Schedule an Interview <IoMdCalendar></IoMdCalendar>
          </span> */}
          <span className="border border-primary rounded-xl p-2 flex justify-around items-center cursor-pointer min-w-[15vh] text-primary" onClick={()=>{CommonStore.setResume(true)}}>
            Resume <FaFilePdf className=" text-primary "></FaFilePdf>
          </span>
          <span className="border border-primary text-white bg-primary rounded-xl cursor-pointer p-2 flex justify-around items-center min-w-[30vh]  " onClick={hireCandidate}>
            Hire this Candidate <MdPersonAddAlt />
          </span>
          
        </span>
      </div>
      <div id="gridContainer" className=" grid md:grid-cols-2 gap-5 px-6">
        <div>
          <h3 className="text-gray-400">Name of the Institute/Company:</h3>
          <p className="text-gray-600">{nameOfInstitute}</p>
        </div>
        <div>
          <h3 className="text-gray-400">Looking For:</h3>
          <p className="text-gray-600 font-bold">{lookingFor}</p>
        </div>
        <div>
          <h3 className="text-gray-400">Location:</h3>
          <p className="text-gray-600">{location?location:'-'}</p>
        </div>
        
        {/* <div>
          <h3 className="text-gray-400">Name of the Company:</h3>
          <p className="text-gray-600">{nameOfCompany}</p>
        </div> */}

        <div>
          <h3 className="text-gray-400">Mail-ID:</h3>
          <p className="text-gray-600">{mailID}</p>
        </div>
        <div>
          <h3 className="text-gray-400">Mobile:</h3>
          <p className="text-gray-600">{mobile}</p>
        </div>

        <div>
          <h3 className="text-gray-400">gender:</h3>
          <p className="text-gray-600">{gender}</p>
        </div>

        {/* <div>
          <h3 className="text-gray-400">Years of Experience:</h3>
          <p className="text-gray-600">{yearsOfExperience}</p>
        </div> */}
        
        <div>
          <h3 className="text-gray-400">Year:</h3>
          <p className="text-gray-600">{year}</p>
        </div>
        
       
        <div>
          <h3 className="text-gray-400">LinkedIN URI:</h3>
          <p className="text-gray-600">{linkedinURI}</p>
        </div>
        <div>
          <h3 className="text-gray-400">Github ID:</h3>
          <p className="text-gray-600">{githubURI}</p>
        </div>
        <div>
          <h3 className="text-gray-400">Technical Score:</h3>
          <p className="text-gray-600">{tech}</p>
          </div>
          <div>
          <h3 className="text-gray-400">Communication Score:</h3>
          <p className="text-gray-600">{communication}</p>
          </div>

          <div>
          <h3 className="text-gray-400">Overall Rating:</h3>
          <p className="text-gray-600">{overallRating}</p>
          </div>
        
        
      </div>
      <div className="flex justify-center px-6 pt-8 w-[100%]">
        <GitHubCalendar
          
          year="2024"
          showWeekdayLabels="true"
          className="w-full h-fit"
          username={props.gitUserName}
        />
      </div>
      <span className="flex justify-around space-x-4 py-10  md:hidden ">
        <span className="border border-primary rounded-xl p-2 flex justify-around items-center  text-primary"  onClick={()=>{alert('Currently the Resume Viewer is available only on web view .')}}>
          Resume <FaFilePdf className=" text-primary "></FaFilePdf>
        </span>
        <span className="border border-primary  text-white bg-primary rounded-xl cursor-pointer p-2  flex justify-around items-center   " onClick={hireCandidate}>
          Hire This Candidate <MdPersonAddAlt/>
        </span>
      </span>
    </div>
  );
}
